
/**
 * 定义一些常量
 */

//年月日的中文字符
export const CONST_YEAR_WORD = ["〇", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
export const CONST_MONTH_WORD = ["正月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "腊月"];
export const CONST_DAY_WORD = ["初一", "初二", "初三", "初四", "初五", "初六", "初七", "初八", "初九", "初十", "十一", "十二", "十三", "十四", "十五", "十六", "十七", "十八", "十九", "二十", "二十一", "二十二", "二十三", "二十四", "二十五", "二十六", "二十七", "二十八", "二十九", "三十", "三十一"];
// 十二时辰
export const CONST_HOUR_WORD = ['子', '丑', '寅', '卯', '辰', '巳', '午', '未', '申', '酉', '戌', '亥'];
// 十二节
export const CONST_MONTH_FEST = ['立春', '惊蛰', '清明', '立夏', '芒种', '小暑', '立秋', '白露', '寒露', '立冬', '大雪', '小寒'];

//五行
export const CONST_WU_XING = "水木火土金";
export const CONST_WU_XING_EN = ["water", "wood", "fire", "soil", "gold"];

//天干
// export const CONST_TIAN_GAN = "0123456789";
export const CONST_TIAN_GAN = "甲乙丙丁戊己庚辛壬癸";
//地支
export const CONST_DI_ZHI = "子丑寅卯辰巳午未申酉戌亥";
//生肖
export const CONST_SHENG_XIAO = "鼠牛虎兔龙蛇马羊猴鸡狗猪";
//藏干
// export const CONST_CANG_GAN = ["癸", "己癸辛", "甲丙戊", "乙", "戊乙癸", "丙庚戊", "丁己", "己丁乙", "庚壬戊", "辛", "戊辛丁", "壬甲"];
export const CONST_CANG_GAN = [[9], [5,9,7], [0,2,4], [1], [4,1,9], [2,6,4], [3,5], [5,3,1], [6,8,4], [7], [4,7,3], [8,0]];


// 命局强弱
export const CONST_STRONG = ['身强', '身弱']
// 命局格局
export const CONST_SITUATION = ['印重局', '命旺局', '伤官局', '财旺局', '煞重局']


//四柱起盘:起始年份
export const CONST_START_END_YEAR = [5, 2100];
//黄历:起始年份
export const CONST_CALENDAR_END_YEAR = [1900, 2100];

//八字分享:随机八字名
export const CONST_SHARE_NAME_LIST = ['私密八字', '隐私八字', '绝密八字', '保密八字', '秘密八字', '隐秘八字', '隐密八字', '机密八字'];

//基础设置:干支十神
export const CONST_SHISHEN_SHOW_TYPES = ['干支', '十神', '藏干', '五行', '纳音'];

// 百科顶部按钮不同状态下的按钮值
export const CONST_FAMOUS_PEDIA_EDIT_TYPE = {
    modify: 'modify',
    check: 'check',
    edit: 'edit',
    read: 'read'
};

// 论盘消息类型对应的值
export const CONST_DISCUSS_MSG_TYPE = {
    text: 1,
    image: 2,
    voice: 3,
    at: 4,
    birth: 5,
    recall: 6,
    reply: 7,
    like: 8
};

// 定时器时间
export const CONST_GET_CODE_TIME = 60;

// 起卦方式列表
export const CONST_DIAGRAM_TYPE = [
    {value: 1, text: '正时起卦'},
    {value: 2, text: '手工指定'},
    {value: 3, text: '卦名起卦'},
    {value: 4, text: '三位数报数'},
    {value: 5, text: '固定三位数'},
    {value: 6, text: '固定四位数'},
    {value: 7, text: '铜钱起卦'},
]
// 卦的状态
export const CONST_DIAGRAM_STATUS = ['神断', '大部分对', '失手了']
// 八纯卦
export const CONST_DIAGRAM_ORIGINAL = [
    {value: 1, text: '乾', wuxing: '金', yao: [1,1,1], waigua: ['壬戌土', '壬申金', '壬午火'], neigua: ['甲辰土', '甲寅木', '甲子水']},
    {value: 2, text: '兑', wuxing: '金', yao: [0,1,1], waigua: ['丁未土', '丁酉金', '丁亥水'], neigua: ['丁丑土', '丁卯木', '丁巳火']},
    {value: 3, text: '离', wuxing: '火', yao: [1,0,1], waigua: ['己巳火', '己未土', '己酉金'], neigua: ['己亥水', '己丑土', '己卯木']},
    {value: 4, text: '震', wuxing: '木', yao: [0,0,1], waigua: ['庚戌土', '庚申金', '庚午火'], neigua: ['庚辰土', '庚寅木', '庚子水']},
    {value: 5, text: '巽', wuxing: '木', yao: [1,1,0], waigua: ['辛卯木', '辛巳火', '辛未土'], neigua: ['辛酉金', '辛亥水', '辛丑土']},
    {value: 6, text: '坎', wuxing: '水', yao: [0,1,0], waigua: ['戊子水', '戊戌土', '戊申金'], neigua: ['戊午火', '戊辰土', '戊寅木']},
    {value: 7, text: '艮', wuxing: '土', yao: [1,0,0], waigua: ['丙寅木', '丙子水', '丙戌土'], neigua: ['丙申金', '丙午火', '丙辰土']},
    {value: 8, text: '坤', wuxing: '土', yao: [0,0,0], waigua: ['癸酉金', '癸亥水', '癸丑土'], neigua: ['乙卯木', '乙巳火', '乙未土']},
]
// 八宫六十四卦列表
export const CONST_DIAGRAM_ALL = [
    {gong: '乾宫', value: 1, gua: [
        {gong: 1, gongStr: '乾', value: 1, wuxing: '金', text: '乾为天', yao: [1,1,1,1,1,1], describe: '六冲'},
        {gong: 1, gongStr: '乾', value: 2, wuxing: '金', text: '天风姤', yao: [1,1,1,1,1,0], describe: ''},
        {gong: 1, gongStr: '乾', value: 3, wuxing: '金', text: '天山遁', yao: [1,1,1,1,0,0], describe: ''},
        {gong: 1, gongStr: '乾', value: 4, wuxing: '金', text: '天地否', yao: [1,1,1,0,0,0], describe: '六合'},
        {gong: 1, gongStr: '乾', value: 5, wuxing: '金', text: '风地观', yao: [1,1,0,0,0,0], describe: ''},
        {gong: 1, gongStr: '乾', value: 6, wuxing: '金', text: '山地剥', yao: [1,0,0,0,0,0], describe: ''},
        {gong: 1, gongStr: '乾', value: 7, wuxing: '金', text: '火地晋', yao: [1,0,1,0,0,0], describe: '游魂'},
        {gong: 1, gongStr: '乾', value: 8, wuxing: '金', text: '火天大有', yao: [1,0,1,1,1,1], describe: '归魂'}
    ]},
    {gong: '兑宫', value: 2, gua: [
        {gong: 2, gongStr: '兑', value: 1, wuxing: '金', text: '兑为泽', yao: [0,1,1,0,1,1], describe: '六冲'},
        {gong: 2, gongStr: '兑', value: 2, wuxing: '金', text: '泽水困', yao: [0,1,1,0,1,0], describe: '六合'},
        {gong: 2, gongStr: '兑', value: 3, wuxing: '金', text: '泽地萃', yao: [0,1,1,0,0,0], describe: ''},
        {gong: 2, gongStr: '兑', value: 4, wuxing: '金', text: '泽山咸', yao: [0,1,1,1,0,0], describe: ''},
        {gong: 2, gongStr: '兑', value: 5, wuxing: '金', text: '水山蹇', yao: [0,1,0,1,0,0], describe: ''},
        {gong: 2, gongStr: '兑', value: 6, wuxing: '金', text: '地山谦', yao: [0,0,0,1,0,0], describe: ''},
        {gong: 2, gongStr: '兑', value: 7, wuxing: '金', text: '雷山小过', yao: [0,0,1,1,0,0], describe: '游魂'},
        {gong: 2, gongStr: '兑', value: 8, wuxing: '金', text: '雷泽归妹', yao: [0,0,1,0,1,1], describe: '归魂'}
    ]},
    {gong: '离宫', value: 3, gua: [
        {gong: 3, gongStr: '离', value: 1, wuxing: '火', text: '离为火', yao: [1,0,1,1,0,1], describe: '六冲'},
        {gong: 3, gongStr: '离', value: 2, wuxing: '火', text: '火山旅', yao: [1,0,1,1,0,0], describe: ''},
        {gong: 3, gongStr: '离', value: 3, wuxing: '火', text: '火风鼎', yao: [1,0,1,1,1,0], describe: ''},
        {gong: 3, gongStr: '离', value: 4, wuxing: '火', text: '火水未济', yao: [1,0,1,0,1,0], describe: ''},
        {gong: 3, gongStr: '离', value: 5, wuxing: '火', text: '山水蒙', yao: [1,0,0,0,1,0], describe: ''},
        {gong: 3, gongStr: '离', value: 6, wuxing: '火', text: '风水涣', yao: [1,1,0,0,1,0], describe: ''},
        {gong: 3, gongStr: '离', value: 7, wuxing: '火', text: '天水讼', yao: [1,1,1,0,1,0], describe: '游魂'},
        {gong: 3, gongStr: '离', value: 8, wuxing: '火', text: '天火同人', yao: [1,1,1,1,0,1], describe: '归魂'}
    ]},
    {gong: '震宫', value: 4, gua: [
        {gong: 4, gongStr: '震', value: 1, wuxing: '木', text: '震为雷', yao: [0,0,1,0,0,1], describe: '六冲'},
        {gong: 4, gongStr: '震', value: 2, wuxing: '木', text: '雷地豫', yao: [0,0,1,0,0,0], describe: '六合'},
        {gong: 4, gongStr: '震', value: 3, wuxing: '木', text: '雷水解', yao: [0,0,1,0,1,0], describe: ''},
        {gong: 4, gongStr: '震', value: 4, wuxing: '木', text: '雷风恒', yao: [0,0,1,1,1,0], describe: ''},
        {gong: 4, gongStr: '震', value: 5, wuxing: '木', text: '地风升', yao: [0,0,0,1,1,0], describe: ''},
        {gong: 4, gongStr: '震', value: 6, wuxing: '木', text: '水风井', yao: [0,1,0,1,1,0], describe: ''},
        {gong: 4, gongStr: '震', value: 7, wuxing: '木', text: '泽风大过', yao: [0,1,1,1,1,0], describe: '游魂'},
        {gong: 4, gongStr: '震', value: 8, wuxing: '木', text: '泽雷随', yao: [0,1,1,0,0,1], describe: '归魂'}
    ]},
    {gong: '巽宫', value: 5, gua: [
        {gong: 5, gongStr: '巽', value: 1, wuxing: '木', text: '巽为风', yao: [1,1,0,1,1,0], describe: '六冲'},
        {gong: 5, gongStr: '巽', value: 2, wuxing: '木', text: '风天小畜', yao: [1,1,0,1,1,1], describe: ''},
        {gong: 5, gongStr: '巽', value: 3, wuxing: '木', text: '风火家人', yao: [1,1,0,1,0,1], describe: ''},
        {gong: 5, gongStr: '巽', value: 4, wuxing: '木', text: '风雷益', yao: [1,1,0,0,0,1], describe: ''},
        {gong: 5, gongStr: '巽', value: 5, wuxing: '木', text: '天雷无妄', yao: [1,1,1,0,0,1], describe: '六冲'},
        {gong: 5, gongStr: '巽', value: 6, wuxing: '木', text: '火雷噬嗑', yao: [1,0,1,0,0,1], describe: ''},
        {gong: 5, gongStr: '巽', value: 7, wuxing: '木', text: '山雷颐', yao: [1,0,0,0,0,1], describe: '游魂'},
        {gong: 5, gongStr: '巽', value: 8, wuxing: '木', text: '山风蛊', yao: [1,0,0,1,1,0], describe: '归魂'}
    ]},
    {gong: '坎宫', value: 6, gua: [
        {gong: 6, gongStr: '坎', value: 1, wuxing: '水', text: '坎为水', yao: [0,1,0,0,1,0], describe: '六冲'},
        {gong: 6, gongStr: '坎', value: 2, wuxing: '水', text: '水泽节', yao: [0,1,0,0,1,1], describe: '六合'},
        {gong: 6, gongStr: '坎', value: 3, wuxing: '水', text: '水雷屯', yao: [0,1,0,0,0,1], describe: ''},
        {gong: 6, gongStr: '坎', value: 4, wuxing: '水', text: '水火既济', yao: [0,1,0,1,0,1], describe: ''},
        {gong: 6, gongStr: '坎', value: 5, wuxing: '水', text: '泽火革', yao: [0,1,1,1,0,1], describe: ''},
        {gong: 6, gongStr: '坎', value: 6, wuxing: '水', text: '雷火丰', yao: [0,0,1,1,0,1], describe: ''},
        {gong: 6, gongStr: '坎', value: 7, wuxing: '水', text: '地火明夷', yao: [0,0,0,1,0,1], describe: '游魂'},
        {gong: 6, gongStr: '坎', value: 8, wuxing: '水', text: '地水师', yao: [0,0,0,0,1,0], describe: '归魂'}
    ]},
    {gong: '艮宫', value: 7, gua: [
        {gong: 7, gongStr: '艮', value: 1, wuxing: '土', text: '艮为山', yao: [1,0,0,1,0,0], describe: '六冲'},
        {gong: 7, gongStr: '艮', value: 2, wuxing: '土', text: '山火贲', yao: [1,0,0,1,0,1], describe: '六合'},
        {gong: 7, gongStr: '艮', value: 3, wuxing: '土', text: '山天大畜', yao: [1,0,0,1,1,1], describe: ''},
        {gong: 7, gongStr: '艮', value: 4, wuxing: '土', text: '山泽损', yao: [1,0,0,0,1,1], describe: ''},
        {gong: 7, gongStr: '艮', value: 5, wuxing: '土', text: '火泽睽', yao: [1,0,1,0,1,1], describe: ''},
        {gong: 7, gongStr: '艮', value: 6, wuxing: '土', text: '天泽履', yao: [1,1,1,0,1,1], describe: ''},
        {gong: 7, gongStr: '艮', value: 7, wuxing: '土', text: '风泽中孚', yao: [1,1,0,0,1,1], describe: '游魂'},
        {gong: 7, gongStr: '艮', value: 8, wuxing: '土', text: '风山渐', yao: [1,1,0,1,0,0], describe: '归魂'}
    ]},
    {gong: '坤宫', value: 8, gua: [
        {gong: 8, gongStr: '坤', value: 1, wuxing: '土', text: '坤为地', yao: [0,0,0,0,0,0], describe: '六冲'},
        {gong: 8, gongStr: '坤', value: 2, wuxing: '土', text: '地雷复', yao: [0,0,0,0,0,1], describe: '六合'},
        {gong: 8, gongStr: '坤', value: 3, wuxing: '土', text: '地泽临', yao: [0,0,0,0,1,1], describe: ''},
        {gong: 8, gongStr: '坤', value: 4, wuxing: '土', text: '地天泰', yao: [0,0,0,1,1,1], describe: '六合'},
        {gong: 8, gongStr: '坤', value: 5, wuxing: '土', text: '雷天大壮', yao: [0,0,1,1,1,1], describe: '六冲'},
        {gong: 8, gongStr: '坤', value: 6, wuxing: '土', text: '泽天夬', yao: [0,1,1,1,1,1], describe: ''},
        {gong: 8, gongStr: '坤', value: 7, wuxing: '土', text: '水天需', yao: [0,1,0,1,1,1], describe: '游魂'},
        {gong: 8, gongStr: '坤', value: 8, wuxing: '土', text: '水地比', yao: [0,1,0,0,0,0], describe: '归魂'}
    ]},
]
// 六爻的六亲
export const CONST_DIAGRAM_LIUQIN = ['父母', '兄弟', '子孙', '妻财', '官鬼'];
// 六爻的六神
export const CONST_DIAGRAM_LIUSHEN = ['青龙', '朱雀', '勾陈', '腾蛇', '白虎', '玄武']
export const CONST_DIAGRAM_LIUSHEN_ALL = ['青龙', '青龙', '朱雀', '朱雀', '勾陈', '腾蛇', '白虎', '白虎', '玄武', '玄武']
// 六爻的全部记录列表
export const CONST_DIAGRAM_RECORD_ALL_LIST = ['全部记录', '有反馈', '无反馈', '正时起卦', '手工指定', '卦名起卦', '三位数报数', '固定三位数', '固定四位数', '铜钱起卦']

//五行文本
export const CONST_WU_XING_TEXT = ['金','木','水','火','土'];
//五行样式
export const CONST_WU_XING_CLASS = ['gold', 'wood', 'water', 'fire', 'solid'];
//颜色样式
export const CONST_COLOR_CLASS = ['white', 'green', 'blue', 'red', 'yellow'];
//排序文字
export const CONST_RANK_TEXT = ['大吉', '次吉', '第三', '第四', '不推荐'];
//周几
export const CONST_WEEK_WORD = ["日", "一", "二", "三", "四", "五", "六"];